export default __webpack_public_path__ + "static/media/getInTouch.da646636.webp";